import { toast } from "react-toastify";
import _ from "lodash";

import NotificationClient from "../../../api/notification";

toast.configure();
export const notifications = {
  state: {
    allNotifications: [],
    branchString: "0",
    branchNumbers: 0,
    lastNotificationId: 0,
  },
  reducers: {
    setNotifications(state, payload) {
      const lastNotification = payload.reduce(
        (prev, current) => {
          if (+current.id > +prev.id) {
            return current;
          } else {
            return prev;
          }
        },
        { id: 0 }
      );

      return {
        ...state,
        allNotifications: [...payload, ...state.allNotifications],
        lastNotificationId:
          (lastNotification && lastNotification.id) || state.lastNotificationId,
      };
    },
    setReadNotification(state, payload) {
      return {
        ...state,
        allNotifications: state.allNotifications.map((notification) => {
          if (notification.compoundId === payload.compoundId) {
            return {
              ...notification,
              read_date: payload.read_date,
            };
          }
          return notification;
        }),
      };
    },

    setBranchIds(state, payload) {
      return {
        ...state,
        branchNumbers: payload,
        lastNotificationId: 0,
      };
    },
    setBranchIdsString(state, payload) {
      return {
        ...state,
        branchString: payload,
      };
    },
    setLastNotificationId(state, payload) {
      return {
        ...state,
        lastNotificationId: payload,
      };
    },
    clearStore() {
      return {
        allNotifications: [],
        branchString: "0",
        branchNumbers: 0,
        lastNotificationId: 0,
      };
    },
  },
  effects: (dispatch) => ({
    async setNotificationsStoredAsync(payload, lastState) {
      try {
        if (
          payload.length &&
          !lastState.notifications.allNotifications.length
        ) {
          const selectedNotifications = localStorage.getItem(
            "selectedNotifications"
          );
          if (selectedNotifications) {
            this.setAllNotifications(JSON.parse(selectedNotifications));
          }
        }
        if (!payload.length) {
          localStorage.setItem("selectedNotifications", JSON.stringify([]));
          this.setAllNotifications([]);
        }
      } catch (err) {
        toast.error("Ops :( Algo deu errado com as notificações !");
      }
    },
    async getNotificationsByRegionAsync(payload = null, lastState) {
      try {
        const {
          // notifications: { allNotifications, branchRegionString, lastNotificationId },
          notifications: { allNotifications, branchRegionString },
          auth: {
            envSettings: { notificationTimeInterval },
          },
        } = lastState;

        if (payload && !payload.length) {
          return this.clearStore();
        }

        let newSelectedBranchRegion = payload
          ? payload.map((i) => i.value).join()
          : branchRegionString;

        if (Array.isArray(newSelectedBranchRegion)) {
          newSelectedBranchRegion = newSelectedBranchRegion.toString();
        }

        // const auxNotificationId =
        //   newSelectedBranchRegion !== branchRegionString ? 0 : lastNotificationId;

        // const res = await NotificationClient.getNotificationsByBranchRegions(
        //   newSelectedBranchRegion,
        //   auxNotificationId
        // );

        // const data = res.data.map((data) => {
        //   return { ...data, compoundId: `${data.id}-OC`, type: 'OC' };
        // });
        const data = [];

        const mergedNotifications = [...data];

        const responseDataNoDuplicate = _.uniqBy(mergedNotifications, "compoundId");

        const notificationToStore = _.differenceBy(
          responseDataNoDuplicate,
          allNotifications,
          "compoundId"
        );

        this.setNotifications(notificationToStore);

        clearTimeout(window.generalNotificationInterval);
        window.generalNotificationInterval = setTimeout(() => {
          this.getNotificationsByRegionAsync();
        }, notificationTimeInterval);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async getNotificationsAsync(payload = null, lastState) {
      try {
        const {
          // notifications: { allNotifications, branchString, lastNotificationId },
          notifications: { allNotifications, branchString },
          auth: {
            envSettings: { notificationTimeInterval },
          },
        } = lastState;

        if (payload && !payload.length) {
          return this.clearStore();
        }

        let newSelectedBranch = payload
          ? payload.map((i) => i.value).join()
          : branchString;

        // force cast to string
        if (Array.isArray(newSelectedBranch)) {
          newSelectedBranch = newSelectedBranch.toString();
        }

        // const auxNotificationId =
        //   newSelectedBranch !== branchString ? 0 : lastNotificationId;

        // const res = await NotificationClient.getNotifications(
        //   newSelectedBranch,
        //   auxNotificationId
        // );

        // const data = res.data.map((data) => {
        //   return { ...data, compoundId: `${data.id}-OC`, type: 'OC' };
        // });
        const data = [];

        const mergedNotifications = [...data];

        const responseDataNoDuplicate = _.uniqBy(mergedNotifications, "compoundId");

        const notificationToStore = _.differenceBy(
          responseDataNoDuplicate,
          allNotifications,
          "compoundId"
        );

        this.setNotifications(notificationToStore);

        clearTimeout(window.generalNotificationInterval);
        window.generalNotificationInterval = setTimeout(() => {
          this.getNotificationsAsync();
        }, notificationTimeInterval);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async setBranchIdsAsync(payload, rootState) {
      if(payload){
        await this.setBranchIdsString(payload);
        await this.setBranchIds(
           JSON.parse("[" + payload + "]")
         );
      } else {
       await this.setBranchIdsString(rootState.branches.filteredBranchString);
       await this.setBranchIds(
          JSON.parse("[" + rootState.branches.filteredBranchString + "]")
        );
       }
    },
    async getNotificationsFromSchedConfigAsync(payload = null, lastState) {
      try {
        const {
          notifications: { allNotifications, branchString },
          auth: {
            envSettings: { notificationTimeInterval },
          },
        } = lastState;

        if (payload && !payload.length) {
          return this.clearStore();
        }

        let newSelectedBranch = payload
          ? payload.map((i) => i.value).join()
          : branchString;

        // force cast to string
        if (Array.isArray(newSelectedBranch)) {
          newSelectedBranch = newSelectedBranch.toString();
        }

        const schedulingNotifications = await NotificationClient.getSchedulingConfig();
        const schedulingNotificationsData = schedulingNotifications.data.map((data) => {
          return { ...data, compoundId: `${data.id}-AG`, type: 'AG' };
        });

        const mergedNotifications = [...schedulingNotificationsData];

        const responseDataNoDuplicate = _.uniqBy(mergedNotifications, "compoundId");
        const notificationToStore = _.differenceBy(
          responseDataNoDuplicate,
          allNotifications,
          "compoundId"
        );

        this.setNotifications(notificationToStore);

        clearTimeout(window.schedulingNotificationInterval);
        window.schedulingNotificationInterval = setTimeout(() => {
          this.getNotificationsFromSchedConfigAsync();
        }, notificationTimeInterval);
      } catch (error) {
        toast.error("Ops :( Algo deu errado !");
      }
    },
    setLastNotificationId(lastNotificationId) {
      return this.setLastNotificationId(lastNotificationId);
    },
    async setReadNotificationsAsync(notification, rootState) {
      try {
        // await NotificationClient.setReadNotification(notification.id);
        // this.setReadNotification(notification);
      } catch (error) {
        await toast.error("Algo deu errado :(!", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    },
    async setSchedulingConfigAsReadAsync(notification) {
      try {
        await NotificationClient.setSchedulingConfigAsRead(notification);
        this.setReadNotification(notification);
      } catch (error) {
        await toast.error("Algo deu errado :(!", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  }),
};
